module.exports = __webpack_public_path__ + "img/mental2.093354f4.png";